export type KpiDelta = {
  value: number;
  colorClass: string;
  iconClass: string;
};

export const resolveKpiDelta = (deltaPercentage: number | null = 0): KpiDelta => {
  const value = deltaPercentage ?? 0;

  if (value > 0) return { value, colorClass: "text-color-success", iconClass: "rioglyph-arrow-up" };
  if (value < 0) return { value, colorClass: "text-color-danger", iconClass: "rioglyph-arrow-down" };

  return { value: 0, colorClass: "text-color-gray", iconClass: "rioglyph-sort" };
};
